import { gql } from 'apollo-boost';

export const PASSWORD_RESET_CREATE = gql`
    mutation PasswordResetCreate($input: PasswordResetCreateInput!) {
      password_reset_create(input: $input) {
          message
      }
  }
`;
